import ApiService from "@/api/ApiService";
import { StoffstromOrder } from "@/components/planning/Project";
import ConfirmDialog from "@/shared/dialogs/ConfirmDialog";
import { Add, Delete, Edit } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Fragment } from "react";
import AddStoffstromDialog from "../planning/dialogs/AddStoffstromDialog";
import useRights from "@/shared/api/useRights";

export function DirectStoffstromCreator({ plannedStart, plannedEnd }: { plannedStart: string; plannedEnd: string }) {
  const queryClient = useQueryClient();

  const rights = useRights();

  const plant = "PLANT" in rights ? parseInt(rights["PLANT"]) : 0;

  const saveMutation = useMutation<StoffstromOrder, AxiosResponse, StoffstromOrder>({
    mutationFn: ApiService.createEntity("stoffstromEntry"),
    onSuccess: (answer) => {
      queryClient.invalidateQueries({
        queryKey: ["stoffstrom"],
      });
    },
  });

  return plant > 0 ? (
    <Fragment>
      <AddStoffstromDialog
        save={function (order: StoffstromOrder): void {
          saveMutation.mutate({ ...order, plant, project: null });
        }}
        OpenButton={({ onClick }) => (
          <Button size="small" startIcon={<Add />} onClick={onClick}>
            Neuer Eintrag
          </Button>
        )}
        initialState={null}
        plannedStart={plannedStart}
        plannedEnd={plannedEnd}
      />
    </Fragment>
  ) : null;
}
